import React, { useMemo } from 'react'

import { ASCENDING, SortDirection } from '../../../../../../../DomainPresentation/utils'
import { GenericPlatformEntity } from '../../../../../../models'

import { AdAccountPixels } from './AdAccountPixels'

interface IdsListProps {
  accountsToShow: GenericPlatformEntity[]
  selectedAccounts: number[]
  handleSelect: (a: number) => void
  isReadOnly?: boolean
  isAllSelected?: boolean
  sortDirection: SortDirection
}

export const PixelsList = ({ accountsToShow, sortDirection, ...props }: IdsListProps) => {
  const pixelsByAdAccount = useMemo(() => {
    return accountsToShow.reduce((acc, pixel) => {
      const adAccountId = pixel.adAccount?.adAccountId ?? ''
      const adAccountName = pixel.adAccount?.name
        ? pixel.adAccount?.name
        : `Ad Account ${adAccountId}`

      if (!!adAccountId && !acc[adAccountName]) {
        acc[adAccountName] = []
      }
      if (adAccountId) {
        acc[adAccountName].push(pixel)
      }
      return acc
    }, {} as Record<string, GenericPlatformEntity[]>)
  }, [accountsToShow])

  // sorts title aka ad account name
  const sortedPixelsKeys = useMemo(() => {
    return Object.keys(pixelsByAdAccount).sort((a, b) => {
      if (sortDirection === ASCENDING) {
        return a.localeCompare(b)
      } else {
        return b.localeCompare(a)
      }
    })
  }, [pixelsByAdAccount, sortDirection])

  return (
    <>
      {sortedPixelsKeys.map((account: string) => (
        <AdAccountPixels
          key={account}
          adAccountName={account}
          pixelsToShow={pixelsByAdAccount[account] ?? []}
          {...props}
        />
      ))}
    </>
  )
}
